import type { StaticTextResource } from '../keys'

export const zhTW: StaticTextResource = {
  'schedule.dueToday': '今天{{time}}截止',
  'schedule.dueTomorrow': '明天{{time}}截止',
  'schedule.durationRange':
    '{{start}} - {{end}} (第{{currentDay}}天 / {{days}}天)',
  'editReport.defaultPageName': '第{{n}}頁',
  'editReport.defaultSectionName': '區塊',
  'editReport.defaultRepeatSectionName': '重複區塊',
}
